import { module }from 'stereomodularjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ResizeObserver from 'resize-observer-polyfill';
//import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            mousedown: {
                showSub: 'showSub',
            },
            keypress: {
                showSub: 'showSub',
            },
            touchstart: {
                showSub: 'showSub',
            }
        }
        this.subnavs = document.querySelectorAll('[data-navAnchors="subnav"]');
    }

    // Show anchor subnav
    showSub(el) {
        if(!el.key || el.key == 'Enter'){
            let target = el.currentTarget
            let subEl = target.nextElementSibling;
            if (subEl.classList.contains('is-active')) {
                classRemove(subEl, 'is-active');
                this.isSubOpen = false;
            } else {
                classRemove(this.subnavs, 'is-active');
                classAdd(subEl, 'is-active');
                this.isSubOpen = true;
            }
        }
    }

    init() {

        const sections = gsap.utils.toArray('*[data-anchor]');
        let isSubOpen = false; // subnav state
        

        // Set scroll trigger for progress
        if (sections) {
            for (let i = 0; i < sections.length; i++) {
                const section = sections[i];
                ScrollTrigger.create({
                    trigger: section,
                    start: 'top 30%',
                    end: 'bottom 27%',
                    onEnter: () => {
                        classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                    },
                    onLeave: () => {
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                    },
                    onEnterBack: () => {
                        classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                    },
                    onLeaveBack: () => {
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                    },
                    onUpdate: (self) => {
                        const html = document.documentElement;
                        const progress = self.progress.toFixed(2);
                        const percent = progress * 100;
                        const percentRounded = Math.round(progress * 100);
                        const progressBarEl = document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').nextElementSibling;
                        let innertia = Math.abs(self.getVelocity());
                        document.activeElement.blur();

                        if (progress && progressBarEl) {
                            progressBarEl.style.cssText += `width: ${percent}%;`;
                        }

                        //show the current innertia
                        if (document.querySelector('[data-navAnchors="subnav"].is-active') && this.isSubOpen && innertia > 200){
                            this.isSubOpen = false;
                            setTimeout(() => {
                                classRemove(document.querySelectorAll('[data-navAnchors="subnav"].is-active'), 'is-active');
                            },300);
                        }
                    },
                    // markers: true
                });
            }
        }

        // Close subnav when click outside anchor nav
        eventAdd(window, 'click', (e) => {
            const clickInsideNav = this.el.contains(e.target);
            const clickInsideNavParent = this.el.contains(e.target.parentNode);
            if (document.querySelector('[data-navAnchors="subnav"].is-active') && this.isSubOpen && !clickInsideNav && !clickInsideNavParent) {
                this.isSubOpen = false;
                setTimeout(() => {
                    classRemove(document.querySelectorAll('[data-navAnchors="subnav"].is-active'), 'is-active');
                }, 150);
            }
        });
    }
}
